import Services from './index.service';

import buildQuery from 'odata-query';

import { IRequestConfig } from 'models/Axios';
import { IBrand } from 'models/brand';

export default class BrandServices extends Services<any, IBrand> {
  /**
   * Function to get a limited qtd of items
   * @currentPage Range to skip, you need only pass currentPage (ex: currentPage = 1)
   * @pageSize Range to take, you need only pass pageSize (ex: pageSize = 15)
   */

  get = (currentPage?: number, pageSize?: number, orderby?: string, filter?: {}) => {
    const skip = currentPage || 0;
    const top = pageSize || 20;
    const order = orderby ? `${orderby}` : undefined;   
    const filterQuery = buildQuery({ filter: filter });

    let config: IRequestConfig<IBrand> = {
      url: `/brands${filterQuery}`,
      params: {
        $top: `${top}`,
        $skip: `${skip * top}`,
        $orderby: order
      },
    };

    return this.httpRequest(config);
  };
}
